import type { Event, SectorPasswordCheck } from '@/models'
import { HttpErrorService } from '@/services/HttpError.service'
import { eventErrorHandbook } from '@/models/Errors'
import { HttpService } from '@/services/Http.service'
import type { OrderKit } from '@/models/Order/OrderKit.model'

export class EventService {
  private endpoint = '/events'
  private httpErrorService: HttpErrorService<keyof typeof eventErrorHandbook>
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(eventErrorHandbook, 'events')
  }

  async getById(id: number) {
    const url = [this.endpoint, id].join('/')

    return await this.httpService
      .get<Event>(url, {
        requestConfig: { cancellable: true, needCancelAtChangeRoute: true },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async getBySlug(slug: string) {
    const url = [this.endpoint, slug].join('/')

    return await this.httpService
      .get<Event>(url, {
        requestConfig: { cancellable: true, needCancelAtChangeRoute: true },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async checkSectorPassword(body: SectorPasswordCheck) {
    const url = [this.endpoint, 'sector', 'check'].join('/')

    return await this.httpService
      .post(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
        },
        fetchConfig: {
          body,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async getOrderKit(id: number) {
    const url = [this.endpoint, id, 'order-kit'].join('/')

    return await this.httpService
      .post<OrderKit>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
        },
        fetchConfig: {
          body: {},
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
